"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "addSubpath", {
  enumerable: true,
  get: function get() {
    return _addSubpath.addSubpath;
  }
});
Object.defineProperty(exports, "consoleMessage", {
  enumerable: true,
  get: function get() {
    return _consoleMessage.consoleMessage;
  }
});
Object.defineProperty(exports, "isServer", {
  enumerable: true,
  get: function get() {
    return _isServer.isServer;
  }
});
Object.defineProperty(exports, "lngFromReq", {
  enumerable: true,
  get: function get() {
    return _lngFromReq.lngFromReq;
  }
});
Object.defineProperty(exports, "lngPathCorrector", {
  enumerable: true,
  get: function get() {
    return _lngPathCorrector.lngPathCorrector;
  }
});
Object.defineProperty(exports, "lngsToLoad", {
  enumerable: true,
  get: function get() {
    return _lngsToLoad.lngsToLoad;
  }
});
Object.defineProperty(exports, "redirectWithoutCache", {
  enumerable: true,
  get: function get() {
    return _redirectWithoutCache.redirectWithoutCache;
  }
});
Object.defineProperty(exports, "removeSubpath", {
  enumerable: true,
  get: function get() {
    return _removeSubpath.removeSubpath;
  }
});
Object.defineProperty(exports, "subpathFromLng", {
  enumerable: true,
  get: function get() {
    return _subpathFromLng.subpathFromLng;
  }
});
Object.defineProperty(exports, "subpathIsPresent", {
  enumerable: true,
  get: function get() {
    return _subpathIsPresent.subpathIsPresent;
  }
});
Object.defineProperty(exports, "subpathIsRequired", {
  enumerable: true,
  get: function get() {
    return _subpathIsRequired.subpathIsRequired;
  }
});

var _addSubpath = require("./add-subpath");

var _consoleMessage = require("./console-message");

var _isServer = require("./is-server");

var _lngFromReq = require("./lng-from-req");

var _lngPathCorrector = require("./lng-path-corrector");

var _lngsToLoad = require("./lngs-to-load");

var _redirectWithoutCache = require("./redirect-without-cache");

var _removeSubpath = require("./remove-subpath");

var _subpathFromLng = require("./subpath-from-lng");

var _subpathIsPresent = require("./subpath-is-present");

var _subpathIsRequired = require("./subpath-is-required");